import { useCallback, useState } from 'react';

/**
 * useState z zapisem do localStorage.
 *
 * Używane do ustawień interfejsu, które mają przetrwać odświeżenie strony
 * (zwinięty panel boczny, liczba wierszy na stronę). Zapis jest opakowany
 * w try/catch, bo localStorage rzuca w trybie prywatnym niektórych przeglądarek
 * i nie może to wywalić całej aplikacji.
 */
export function useLocalStorageState(key, defaultValue) {
  const [value, setValue] = useState(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored === null ? defaultValue : JSON.parse(stored);
    } catch {
      return defaultValue;
    }
  });

  const update = useCallback(
    (next) => {
      setValue((current) => {
        const resolved = typeof next === 'function' ? next(current) : next;
        try {
          localStorage.setItem(key, JSON.stringify(resolved));
        } catch {
          /* brak trwałości, ale stan w pamięci działa dalej */
        }
        return resolved;
      });
    },
    [key]
  );

  return [value, update];
}

export default useLocalStorageState;
